import { IMDSCalendarGridProps } from "@/mds/components/date-time/calendars/calendar-grid/calendar-grid.types";
import { StyledCalendarGrid } from "@/mds/components/date-time/calendars/calendar-grid/calendar-grid.style";

export function MDSCalendarGrid(props: IMDSCalendarGridProps) {
  return <StyledCalendarGrid {...props} />;
}
